import { Box } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { MultiSelect } from 'react-multi-select-component'
import { useStore } from '../../stores/store'

const EditUser = () => {
  const { userStore } = useStore()
  const { selectedUser, updateUserRole } = userStore

  const initialState = selectedUser ?? {
    id: '',
    avatar: '',
    token: '',
    email: '',
    firstName: '',
    lastName: '',
    userRoles: [],
  }

  const [user, setUser] = useState(initialState)
  const [roles, setRoles]: any = useState([])

  const setUserRoles = () => {
    const rolesSelected = initialState.userRoles.map((r) => ({
      label: r,
      value: r,
    }))
    setRoles(rolesSelected)
  }

  useEffect(() => {
    if (selectedUser) {
      setUser(selectedUser)
    }
    setUserRoles()
  }, [selectedUser])

  const handleSubmit = (e: any) => {
    e.preventDefault()
    const roleToPush: any = []
    roles.forEach((r: any) => {
      roleToPush.push(r.value)
    })
    updateUserRole(user, roleToPush)
    userStore.setEditUserModal(false)
  }

  const handleChange = (e: any) => {
    setRoles(e)
  }

  const rolesType = [
    { label: 'Admin', value: 'Admin' },
    { label: 'User', value: 'User' },
    { label: 'Suspended', value: 'Suspended' },
    { label: 'Moderator', value: 'Moderator' },
  ]

  return (
    <>
      <Modal.Header closeButton>
        <h5 className='modal-title text-dark'>Edit User Role</h5>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <div className='modal-body'>
            <Box
              sx={{
                '& > :not(style)': { m: 1 },
              }}
              className='d-flex justify-content-center flex-column ps-3 pe-4 me-1'
            >
              <MultiSelect
                className='editRoleDesign'
                options={rolesType}
                value={roles}
                hasSelectAll={false}
                disableSearch
                onChange={handleChange}
                labelledBy='User Roles'
              />
              <div>{/* -------- Error Here ---------- */}</div>
            </Box>
          </div>
          <div className='modal-footer'>
            <button
              type='button'
              className='btn btn-secondary'
              onClick={() => userStore.setEditUserModal(false)}
            >
              Close
            </button>
            <button type='submit' className='btn btn-danger'>
              Edit User
            </button>
          </div>
        </Form>
      </Modal.Body>
    </>
  )
}
export default observer(EditUser)
